import script from "./CalculatorTariffs.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculatorTariffs.vue?vue&type=script&setup=true&lang=js"

import "./CalculatorTariffs.vue?vue&type=style&index=0&id=dd836154&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd836154"]])

export default __exports__